var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"ul-form",class:_vm.classies,on:{"submit":_vm.submit}},[_vm._t("default"),(_vm.load && !_vm.noLoading)?_c('UlLoad'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }